import Dinero from 'dinero.js';

const AUD_FORMAT = '$0,0.00';
const CURRENCY_FORMATS = {
  AUD: AUD_FORMAT,
  NZD: AUD_FORMAT,
};

const formatCurrency = (amount, currency) => {
  const format = CURRENCY_FORMATS[currency];
  return Dinero({ amount, currency }).toFormat(format);
};

export default formatCurrency;
